import { render, staticRenderFns } from "./doorpassrecord.vue?vue&type=template&id=6967146a&"
import script from "./doorpassrecord.vue?vue&type=script&lang=js&"
export * from "./doorpassrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports